import React, { Component, Context } from "react";
import { connect } from "react-redux";
import clsx from "clsx";
import orderby from "lodash.orderby";
import scrollIntoView from "scroll-into-view-if-needed";
import { IDirectorActionDispatches, mapDirectorDispatchToProps } from "../../../redux/actions/director";
import { IDirectorState, mapDirectorStateToProps } from "../../../redux/reducers/director";
import { WidgetProps } from "..";
import { IDirector } from "../../../laco-common/base/models/director";
import LayoutContext, { ILayoutContext } from "../../../contexts/layout/LayoutContext";
import UILoader from "../../ui/UILoader";
import { PhoneLinkWeb } from "../../ui/PhoneLinkWeb";
import { EmailLinkWeb } from "../../ui/EmailLinkWeb";

const PREVIEW_COUNT: number = 9;

type DirectorsState = {
	loading: boolean;
	displayAll: boolean;
	directors: IDirector[];
};

class Directors extends Component<IDirectorActionDispatches & IDirectorState & WidgetProps, DirectorsState> {
	static contextType: Context<ILayoutContext> = LayoutContext;

	state = {
		loading: true,
		displayAll: false,
		directors: [],
	};

	componentDidMount() {
		this.props
			.loadDirectors()
			.then((data) => {
				let directors = data.map((d: IDirector) => {
					let battalion;
					const assignment = (d.assignment || "").toLowerCase().trim();
					if (assignment.includes("battalion")) {
						battalion = assignment.substring(9).trim();
						const endSpace: number = battalion.indexOf(" ");
						if (endSpace > 0) {
							battalion = battalion.substring(0, battalion.indexOf(" "));
						}
						if (isNaN(battalion)) {
							return d;
						} else {
							console.log("battalion:", battalion);
							return { ...d, battalion: parseInt(battalion) };
						}
					}
					return d;
				});
				directors = orderby(directors, ["order", "battalion", "name"], ["asc", "asc"]);
				this.setState({ directors });
			})
			.finally(() => {
				this.setState({ loading: false });
			});
	}

	toggleDisplayAll() {
		this.setState({ displayAll: !this.state.displayAll });
		if (!this.state.displayAll) return;

		const node = document.querySelector(".directors-container");
		if (!node) return;
		scrollIntoView(node, {
			scrollMode: "if-needed",
			// block: "nearest",
			// inline: "nearest",
			block: "start",
			inline: "start",
		});
	}

	renderMobile() {
		return (this.state.directors || []).map((director: IDirector, i: number) => {
			if (this.props.page?.id !== "bnDirectors" && !this.state.displayAll && i > PREVIEW_COUNT) return;
			return (
				<div key={i} className="item-mobile-row text-sm">
					<h4 className="mb-2">{director.name}</h4>
					<div className="mb-1">{director.assignment}</div>
					<div className="gray-link inner-link mb-1">
						<EmailLinkWeb email={director.email} />
					</div>
					<div className="gray-link inner-link mb-1">
						<PhoneLinkWeb number={director.phone} />
					</div>
				</div>
			);
		});
	}

	render() {
		return (
			<div>
				<div
					className={clsx(
						!this.props.isNested && "container",
						"directors-container d-flex flex-column",
						!this.props.page?.noPadding && "section-padding"
					)}
				>
					<h1 className="highlighted mb-4">Officers and Directors</h1>
					{this.state.loading && <UILoader display={true} />}
					{this.context.settings.isScreenWidthSm && this.renderMobile()}
					{!this.context.settings.isScreenWidthSm && (
						<table className="table text-sm">
							<thead>
								<tr>
									<th scope="col">Assignment</th>
									<th scope="col">Director</th>
									<th scope="col" colSpan={2}>
										Contact
									</th>
								</tr>
							</thead>
							<tbody>
								{(this.state.directors || []).map((director: IDirector, i: number) => {
									if (
										this.props.page?.id !== "bnDirectors" &&
										!this.state.displayAll &&
										i > PREVIEW_COUNT
									)
										return;
									return (
										<tr key={i}>
											<td>{director.assignment}</td>
											<td>{director.name}</td>
											{this.context.settings.isDesktopRes && (
												<>
													<td className="gray-link inner-link">
														<EmailLinkWeb email={director.email} />
													</td>
													<td className="gray-link inner-link">
														<PhoneLinkWeb number={director.phone} />
													</td>
												</>
											)}
											{!this.context.settings.isDesktopRes && (
												<td colSpan={2}>
													<div className="gray-link inner-link">
														<EmailLinkWeb email={director.email} />
													</div>
													<div className="gray-link inner-link">
														<PhoneLinkWeb number={director.phone} />
													</div>
												</td>
											)}
										</tr>
									);
								})}
							</tbody>
						</table>
					)}
					{this.props.page?.id !== "bnDirectors" && (
						<span className="gray-link with-arrow mt-0 text-xs" onClick={() => this.toggleDisplayAll()}>
							View {this.state.displayAll ? "Less" : "All"}
						</span>
					)}
				</div>
			</div>
		);
	}
}

export default connect<IDirectorState, IDirectorActionDispatches, WidgetProps>(
	mapDirectorStateToProps,
	mapDirectorDispatchToProps
)(Directors);
